import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { VariantGridDataService } from '@app/@core/services/variant-grid-data/variant-grid-data.service';

@Component({
    selector: 'sp-variant-delete-alert',
    templateUrl: './variant-delete-alert.component.html',
    styleUrls: ['./variant-delete-alert.component.scss'],
})
export class VariantDeleteAlertComponent implements OnInit {
    variantsCount: number = this.variantGridDataService.stashedGridData.length;
    @Output() closeDeleteAlert = new EventEmitter<void>();

    constructor(private variantGridDataService: VariantGridDataService) {}

    ngOnInit(): void {}

    undoDeleteVariants(): void {
        this.variantGridDataService.addStashedDataBackToVariantGridData();
        this.closeDeleteAlert.emit();
    }

    closeDeleteAlertSnackBar(): void {
        this.closeDeleteAlert.emit();
    }
}
